import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  Grid,
  Input,
  Message,
  Radio,
  Select,
  Switch,
} from '@alifd/next';
import { Image } from 'antd';
import axios from 'axios';
import { history } from 'ice';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import ezconImg from '../../../../../public/ezcon.png';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;
const { Row } = Grid;
const Option = Select.Option;
const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const VoteAddList = () => {
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const [formStyle, setFormStyle] = useState({
    size: 'medium',
    preview: false,
  });

  const [parsed, setParsed] = useState([]);
  const [parsed64, setParsed64] = useState([]); // Base64
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [allows, setAllows] = useState([]);
  const uploadFile = useRef(null);
  const currentDate = moment();
  const currentDate1 = moment().subtract(1, 'days');

  const [checkedList, setCheckedList] = useState(buildRes());
  const [indeterminate, setIndeterminate] = useState(true);
  const [checkAll, setCheckAll] = useState(false);

  useEffect(() => {
    residentAccountNumbers.find({}).then((res) => {
      console.log('res', res);
      setResidentAccountNumbersArr(res.data);
    });
  }, []);

  const onPreviewChange = (checked) => {
    setFormStyle({
      preview: checked,
    });
  };

  // 問題選單
  const [todoList, setTodoList] = useState([]);
  const [optionTitle, setOptionTitle] = useState('');
  const [todoEditing, setTodoEditing] = useState(null);
  const [editingText, setEditingText] = useState('');

  function handleOptionSubmit() {
    const newTodo = {
      id: todoList.length + 1,
      title: optionTitle,
      vote: 0,
    };
    setTodoList((prevList) => prevList.concat(newTodo));
    setOptionTitle('');
  }

  function deleteTodo(id) {
    let updatedTodoList = [...todoList].filter((todo) => todo.id !== id);
    updatedTodoList = updatedTodoList.map((todo, index) => ({
      ...todo,
      id: index + 1,
    }));
    setTodoList(updatedTodoList);
  }

  function submitEdits(id) {
    const updatedTodoList = [...todoList].map((todo) => {
      if (todo.id === id) {
        todo.title = editingText;
      }
      return todo;
    });
    setTodoList(updatedTodoList);
    setTodoEditing(null);
  }

  async function beforeUpload() {
    if (uploadFile.current.files.length > 0) {
      const isLt20M =
        (await uploadFile.current.files[0].size) / 1024 / 1024 < 20;

      if (!isLt20M) {
        Message.error('Image must smaller than 20MB!');
        return Promise.reject();
      }
      Promise.resolve(isLt20M);
    } else {
      setParsed64('');
    }
  }

  const handleFiles = async () => {
    try {
      await beforeUpload();
      const files = [...parsed];
      const data = await uploadFile.current.files[0];
      // console.log(data);
      files.push(data);
      setParsed(files);

      // 轉Base64 上傳檔案後呈現沒有寫到DB
      const reader = new FileReader();
      reader.onload = function () {
        const dataURL = reader.result;
        setParsed64(dataURL);
      };
      reader.readAsDataURL(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async (values, errors) => {
    if (errors) {
      console.log('errors', errors);
      return;
    }

    if (!todoList.length > 0) {
      Message.error('請建立投票選項');
      return;
    }
    if (!allows.length > 0) {
      Message.error('請選擇投票棟別');
      return;
    }
    console.log('values:', values);
    // console.log('optionContent:', optionContent);

    const vote = client.service('vote');

    // 取得voteLength => order
    const voteLength = await vote.find({ query: {} }).then((result) => {
      return result.data;
    });

    // 新寫法

    const formData = new FormData();

    formData.append('order', voteLength.length);
    formData.append('top', values.top);
    formData.append('title', values.title);
    formData.append('content', values.content);
    formData.append('buildTime', new Date(values.buildTime).getTime());
    formData.append('endTime', new Date(values.endTime).getTime());
    formData.append('voteType', values.voteType);
    formData.append('showUserName', values.showUserName);
    formData.append('optionCheck', values.optionCheck);
    formData.append('reSubmittable', values.reSubmittable);
    if (uploadFile.current.files.length > 0) {
      formData.append('files', uploadFile.current.files[0]);
    } else {
      formData.append('files', []);
    }
    formData.append('options', JSON.stringify(todoList));
    formData.append('voters', 0);
    formData.append('allows', JSON.stringify(allows));

    Swal.fire({
      title: '確定投票內容無誤?',
      text: '送出後將無法編輯!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#BEBEBE',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.isConfirmed) {
        axios('/uploads?type=vote', {
          method: 'POST',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data: formData,
        })
          .then((response) => {
            console.log('==vote create result:', response.data || response);
            Swal.fire(
              '成功!',
              '此投票已新增，準備跳轉至投票清單頁面...',
              'success'
            );
            setTimeout(() => {
              history.push('/ezpro/vote/voteList');
            }, 1000);
          })
          .catch((error) => {
            console.log('==vote create fail:', error.message);
            Message.error(
              '建立失敗,請確定必填欄位不為空,投票結束時間不能小於現在'
            );
          });
      }
    });
  };

  const onChange = (list) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < buildRes().length);
    setCheckAll(list.length === buildRes().length);
    residentAccountNumbers
      .find({ query: { building: { $in: list } } })
      .then((res) => {
        setAllows(res.data.map((item) => item.householdNumber));
      });
  };

  const onCheckAllChange = (checked, e) => {
    if (e.target.checked === true) {
      residentAccountNumbers.find({}).then((res) => {
        setAllows(res.data.map((item) => item.householdNumber));
      });
    } else {
      setAllows([]);
    }

    setCheckedList(e.target.checked ? buildRes() : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  function buildRes() {
    const dataSource = [];

    for (let i = 0; i < residentAccountNumbersArr.length; i++) {
      // 第一層
      const building = residentAccountNumbersArr[i].building;
      dataSource.push(building);
    }
    return [...new Set(dataSource.filter((data) => Boolean(data)))];
  }

  const disabledDate = (date, view) => {
    switch (view) {
      case 'date':
        return date.valueOf() <= currentDate1.valueOf();
      case 'year':
        return date.year() < currentDate.year();
      case 'month':
        return (
          date.year() * 100 + date.month() <
          currentDate.year() * 100 + currentDate.month()
        );
      default:
        return false;
    }
  };

  return (
    <>
      <Card free>
        <Card.Content>
          <h1>主題說明</h1>
          <p>設定發起投票標題、時間及說明等</p>
          <Form
            {...formItemLayout}
            isPreview={formStyle.preview}
            size={formStyle.size}
            style={{ maxWidth: '1100px' }}
          >
            <Item
              label="預覽: "
              isPreview={false}
              size="small"
              style={{ marginBottom: 0 }}
            >
              <Switch size="medium" onChange={onPreviewChange} />
            </Item>
            <div style={{ height: 1, width: '100%', margin: '20px 0' }} />
            <Item label="重要事項:">
              <Checkbox name="top" defaultChecked={false}>
                置頂
              </Checkbox>
            </Item>
            <Item required label="標題:" requiredMessage="必填">
              <Input
                placeholder="請輸入標題"
                name="title"
                aria-required="true"
                maxLength={30}
                hasLimitHint
                defaultValue={''}
              />
            </Item>
            <Item label="內容:" required requiredMessage="必填">
              <Input.TextArea
                name="content"
                placeholder="請輸入內容"
                maxLength={200}
                rows={4}
                hasLimitHint
                aria-required="true"
                defaultValue={''}
              />
            </Item>
            <Item label="投票時間:" required requiredMessage="必填">
              <Row>
                <Item
                  required
                  requiredMessage="必填"
                  style={{ marginRight: 30, marginBottom: 0 }}
                >
                  <DatePicker
                    disabledDate={disabledDate}
                    placeholder="開始日期"
                    showTime
                    name="buildTime"
                    defaultValue={moment()}
                  />
                </Item>
                <Item
                  required
                  requiredMessage="必填"
                  style={{ marginBottom: 0 }}
                >
                  <DatePicker
                    disabledDate={disabledDate}
                    placeholder="結束日期"
                    name="endTime"
                    showTime
                    defaultValue={moment().add(1, 'months')}
                  />
                </Item>
              </Row>
            </Item>
            <Item required label="投票限制:" requiredMessage="必填">
              <Select style={{ width: 200 }} name="voteType" defaultValue={1}>
                <Option value={0}>一戶一票</Option>
                <Option value={1}>一人一票</Option>
              </Select>
            </Item>
            <Item
              required
              label="選擇投票棟別:"
              requiredMessage="必填"
              help="此為棟別名稱"
            >
              <Checkbox
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                checked={checkAll}
              >
                全選
              </Checkbox>
              <Checkbox.Group
                className={styles.optionList}
                itemDirection="ver"
                dataSource={buildRes()}
                value={checkedList}
                onChange={onChange}
              />
            </Item>

            <Item label="是否記名:">
              <Radio.Group name="showUserName" defaultValue={false}>
                <Radio value>記名</Radio>
                <Radio value={false}>不記名</Radio>
              </Radio.Group>
            </Item>
            <Item label="選項是否可複選:">
              <Radio.Group name="optionCheck" defaultValue={false}>
                <Radio value>是</Radio>
                <Radio value={false}>否</Radio>
              </Radio.Group>
            </Item>
            <Item label="是否能修改投出結果:">
              <Radio.Group name="reSubmittable" defaultValue={false}>
                <Radio value>是</Radio>
                <Radio value={false}>否</Radio>
              </Radio.Group>
            </Item>

            <Item label="附加圖片:">
              <input
                accept="image/png, image/jpg, image/jpeg"
                ref={uploadFile}
                onChange={handleFiles}
                type="file"
                id="file"
                name="files"
                // multiple
              />

              <Image
                className={styles.photo}
                src={`${parsed64.length > 0 ? parsed64 : ezconImg}`}
                alt="圖片"
              />
            </Item>
            <div id="todo-list">
              <h1>建立問題選項</h1>
              <p>設定新增投票問題、說明即選項等</p>
              <Item>
                <Input
                  placeholder="請輸入標題"
                  type="text"
                  onChange={(value) => setOptionTitle(value)}
                  value={optionTitle}
                />
                <Form.Submit
                  className={styles.addBtn}
                  type="primary"
                  onClick={handleOptionSubmit}
                >
                  新增
                </Form.Submit>
              </Item>
              {todoList.map((todo) => (
                <div key={todo.id} className="todo">
                  <div className="todo-text">
                    <div>順序:{todo.id}</div>
                    {todo.id === todoEditing ? (
                      <Input
                        defaultValue={todo.title}
                        type="text"
                        onChange={(value) => setEditingText(value)}
                      />
                    ) : (
                      <div>標題:{todo.title}</div>
                    )}
                  </div>
                  <div>票數:{todo.vote}</div>
                  <div className="todo-actions">
                    {todo.id === todoEditing ? (
                      <Button
                        type="secondary"
                        onClick={() => submitEdits(todo.id)}
                      >
                        更新
                      </Button>
                    ) : (
                      <Button
                        type="secondary"
                        onClick={() => setTodoEditing(todo.id)}
                      >
                        編輯
                      </Button>
                    )}

                    <Button
                      type="normal"
                      warning
                      onClick={() => deleteTodo(todo.id)}
                    >
                      刪除
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ height: 1, width: '100%', margin: '20px 0' }} />

            <Item wrapperCol={{ offset: 20 }}>
              <Form.Submit
                type="primary"
                onClick={handleSubmit}
                className={styles.submitBtn}
                validate
              >
                送出
              </Form.Submit>
              <Form.Reset style={{ marginLeft: 10 }}>清除</Form.Reset>
            </Item>
          </Form>
        </Card.Content>
      </Card>
    </>
  );
};

export default VoteAddList;
